/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Is_MineInputs */

const en_filter_is_mine = /** @type {(inputs: Filter_Is_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mine`)
};

const de_filter_is_mine = /** @type {(inputs: Filter_Is_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meins`)
};

/**
* | output |
* | --- |
* | "mine" |
*
* @param {Filter_Is_MineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_is_mine = /** @type {((inputs?: Filter_Is_MineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Is_MineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_is_mine(inputs)
	return en_filter_is_mine(inputs)
});